import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "whenOn", "whenOff"]

  connect() {
    this.toggle()
  }

  toggle() {
    const enabled = this.hasTriggerTarget ? Boolean(this.triggerTarget.checked) : false
    this.updateTargets(this.whenOnTargets, enabled)
    this.updateTargets(this.whenOffTargets, !enabled)
  }

  updateTargets(targets, visible) {
    targets.forEach((target) => {
      target.hidden = !visible
      this.setDisabled(target, !visible)
    })
  }

  setDisabled(target, disabled) {
    target
      .querySelectorAll("input, select, textarea, button, wa-input, wa-select, wa-checkbox")
      .forEach((field) => {
        field.disabled = disabled
      })
  }
}
